import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import ModalLoading from '../../../../../components/modalLoading';
import ModalNoti from '../../../../../components/modalNoti';
import { ACCOUNT_IS_LOCKED, OTP_WRONG_MESSAGE, OVER_TIME_GET_OTP_MESSAGE, OVER_TIME_SEND_OTP_MESSAGE, SEND_MAIL_ERROR_MESSAGE } from '../../../../../utils/constants';
import { changeErrorSendOTP, clearErrorSendOTP, downTimeoutOTP, getNewOTP, getOTP, sendOTP } from '../../../redux/action';
import './index.css';

function SendOTP({email}) {
  
  const dispatch = useDispatch();

  const [timeoutOTP,
    getOTPRemain,
    isGettingOTP,
    isGottenOTPSuccess,
    isGottenOTPFail,
    sendOTPRemain,
    isSendingOTP,
    isSentOTPFail,
    errorSendOTP,
  ] = useSelector((state) => [
    state.account.timeoutOTP,
    state.account.getOTPRemain,
    state.account.isGettingOTP,
    state.account.isGottenOTPSuccess,
    state.account.isGottenOTPFail,
    state.account.sendOTPRemain,
    state.account.isSendingOTP,
    state.account.isSentOTPFail,
    state.account.errorSendOTP,
  ]);

  const [showFailPopup, setShowFailPopup] = useState(false);
  
  const onSendOTP = (data) => {
    dispatch(sendOTP({
      email: email,
      ...data
    }));
  };
  
  const sendOTPValidationSchema = yup.object().shape({
    otp: yup
    .string()
    .min(6, () => `OTP phải có 6 ký tự`)
    .max(6, () => `OTP phải có 6 ký tự`)
    .required('Chưa nhập OTP')
  });

  const {
    values,
    errors,
    touched,
    isValid,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      otp: '',
    },
    validationSchema: sendOTPValidationSchema,
    onSubmit: onSendOTP,
  });

  
  useEffect(() => {
    if (timeoutOTP !== null) {
      setTimeout(() => {
        dispatch(downTimeoutOTP());
      }, 1000)
    }
  }, [timeoutOTP]);

  useEffect(() => {
    if (isSentOTPFail && errorSendOTP === OTP_WRONG_MESSAGE) {
      dispatch(clearErrorSendOTP());
    }
  }, [values.otp]);

  useEffect(() => {
    if (sendOTPRemain <= 0 && errorSendOTP === '') {
      dispatch(changeErrorSendOTP(OVER_TIME_SEND_OTP_MESSAGE));
    }
  }, [sendOTPRemain, errorSendOTP]);

  useEffect(() => {
    if (getOTPRemain <= 0 && errorSendOTP === '') {
      dispatch(changeErrorSendOTP(OVER_TIME_GET_OTP_MESSAGE));
    } else {
      if (getOTPRemain <= 0 && errorSendOTP === OTP_WRONG_MESSAGE) {
        dispatch(changeErrorSendOTP(ACCOUNT_IS_LOCKED));
      } 
    }
  }, [getOTPRemain, errorSendOTP]);

  useEffect(() => {
    if(isGottenOTPFail && errorSendOTP === SEND_MAIL_ERROR_MESSAGE){
      setShowFailPopup(isGottenOTPFail);
    }
  }, [isGottenOTPFail]);

  const millisToMinutesAndSeconds = (millis) => {
    let minutes = Math.floor(millis / 60000);
    let seconds = ((millis % 60000) / 1000).toFixed(0);

    if(seconds == 60) {
      minutes += 1;
      seconds = 0;
    }
    
    return (minutes < 10 ? '0' : '') + minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
  }

  return (
    <>
      <div className="body">
        <img className='big_bg' src="/login/big_bg.png" alt=""/>
          <div className="mycontainer">
            <img className='frame' src="/login/bg-send-otp.png" alt=""/>
            <div className="content">
              <h2 style={{color: "#499aaf"}} className="text-uppercase">Istorage</h2>
              <p style={{fontSize: "18px", fontStyle: "italic", color: "#499aaf"}}>Hệ thống upload và lưu trữ file</p> <br />
              <p style={{fontStyle: "italic", color: "#499aaf"}}className="noti">{`Bạn vui lòng kiểm tra mail ${email} để lấy OTP`}</p>
              <form onSubmit={(e) => {e.preventDefault()}}>
                <div className="error">
                  <small>{timeoutOTP !== null ? millisToMinutesAndSeconds(timeoutOTP) : "00:00"}</small>
                </div>
                <div className="input-icons">
                  <i className="fal fa-key icon-mail"></i>
                  <input 
                    className="input-field" 
                    type="text" 
                    placeholder="OTP"
                    value={values.otp}
                    onChange={(e) => {
                      let temp = e.target.value.replace(/[^0-9]/g, '');
                      if(temp.length <= 6) {
                        setFieldValue('otp', temp);
                      } else {
                        setFieldValue('otp', temp.substring(0, 6));
                      }
                      
                    }}
                    onBlur={handleBlur('otp')}
                  />
                  {values.otp !== '' && 
                    <i 
                      className="fas fa-times-circle icon-mail icon-right"
                      onClick={() => {
                        setFieldValue('otp', '');
                      }}
                    ></i>
                  }
                </div>
                <div className="error">
                  <small>
                    {timeoutOTP === null ? (
                      <>
                        OTP đã hết hạn. Vui lòng bấm vào đây để 
                        <Button
                          variant="link"
                          style={{ 
                            boxShadow: "none", 
                            padding: '0',
                            fontFamily: 'Roboto',
                            fontStyle: 'italic',
                            fontWeight: '400',
                            fontSize: '16px',
                            color: 'red'}} 
                          onClick={() => {
                            dispatch(getNewOTP({email}))
                          }}
                        >
                          lấy OTP mới.
                        </Button>
                      </>
                    ): 
                      errorSendOTP}
                  </small>
                </div>
                {sendOTPRemain > 0 && timeoutOTP !== null && errorSendOTP !== ACCOUNT_IS_LOCKED &&
                  <button 
                    className={!isValid || isSendingOTP || values.otp === '' ? 'button-otp' : 'button-otp active'}
                    disabled={!isValid || isSendingOTP || values.otp === ''}
                    onClick={handleSubmit}
                  >
                    <i className="fa fa-arrow-right"></i>
                  </button>
                }
              </form>
            {getOTPRemain > 0 && sendOTPRemain > 0 && timeoutOTP !== null && errorSendOTP !== ACCOUNT_IS_LOCKED && 
              <Button
                variant="link"
                style={{fontStyle: "italic", color: "#499aaf", boxShadow: "none"}} 
                className="resend-OTP"
                onClick={() => {
                  if (isSentOTPFail && errorSendOTP === OTP_WRONG_MESSAGE) {
                    dispatch(clearErrorSendOTP());
                  }
                  dispatch(getOTP({email}))
                }}
              >
                Gửi lại OTP
              </Button>
            }
          </div>
        </div>  
      </div>
      
      <ModalNoti 
        show={showFailPopup}
        onHide={() => {setShowFailPopup(false);}}
        closeButton={false}
        content={'Có lỗi trong quá trình gửi OTP.'}
        leftButton={{
          onClick: () => {
            setShowFailPopup(false);
          },
          content: 'Đóng'
        }}
        rightButton={{
          onClick: () => {
            if(timeoutOTP === null) {
              dispatch(getNewOTP({email}));
            } else {
              dispatch(getOTP({email}));
            }
            setShowFailPopup(false);
          },
          content: 'Thử lại',
        }}
      ></ModalNoti>

      <ModalLoading show={isGettingOTP || isSendingOTP} content={'Đang xử lý...'}></ModalLoading>
    </>
  );
}

export default SendOTP;